module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var types = [
	{ name:'Push Button', value: 'push'},
	{name:'Rectangular Mouse Over Button', value: 'rectMouseOver'},
	{name:'Rounded Mouse Over Button', value: 'roundMouseOver'}
];

    ; __append("\r\n<div class=\"row prop-detail\">\r\n	<div class=\"row\">\r\n		<div class=\"col-md-12 subsection nopadding-r\"> \r\n			<label class=\"prop-sublabel label-65\">Button Type</label> \r\n			<div >\r\n				<select name=\"buttonStyle\" id=\"buttonStyle\">\r\n					")
    ;  for (var i = 0; i < types.length; i++) { 
    ; __append("\r\n						<option value=\"")
    ; __append(escapeFn(types[i].value))
    ; __append("\">\r\n							")
    ; __append(escapeFn(types[i].name))
    ; __append("\r\n						</option>\r\n					")
    ;  }; 
    ; __append("\r\n				</select>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>")
  }
  return __output;

}